export const PHONE_MAX = 832;
export const TABLET_MAX = 1024;
export const PHONE_MEDIA_QUERY = `(max-width: ${PHONE_MAX}px)`;
export const TABLET_MEDIA_QUERY = `(min-width: ${PHONE_MAX + 1}px) and (max-width: ${TABLET_MAX}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${TABLET_MAX + 1}px)`;